const styles = ({ breakpoints, typography }) => ({
  image: {
    height: `${typography.pxToRem(250)} !important`,
    [breakpoints.up('xl')]: {
      height: `${typography.pxToRem(180)} !important`,
    },
  },
});

export default styles;
